var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.832225 0.604931C1.07631 0.360856 1.47204 0.360856 1.71613 0.604931L7.01937 5.90825C7.58896 6.47775 7.58896 7.40108 7.01937 7.97067L1.71613 13.2739C1.47204 13.518 1.07631 13.518 0.832234 13.2739C0.58815 13.0298 0.58815 12.6341 0.832234 12.3901L6.13554 7.08675C6.21687 7.00541 6.21687 6.8735 6.13554 6.79208L0.832234 1.48881C0.58815 1.24474 0.58815 0.849006 0.832225 0.604931Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDown);
export default __webpack_public_path__ + "static/media/RightDown.704ea0ebbd402807f14516a05a27b4b1.svg";
export { ForwardRef as ReactComponent };